import { FunctionComponent } from 'react';

import CheckIcon from 'theme/icons/check-circle-black.svg';

import { Props } from './index';
import StyledComponent from './styles';

const LayoutModal: FunctionComponent<Props> = ({ text }) => {
    return (
        <StyledComponent className="toast-success-container">
            <img
                src={CheckIcon}
                alt=""
                loading="lazy"
            />
            <p>{text}</p>
        </StyledComponent>
    );
};

export default LayoutModal;